import {
  AppShortcutOutlined,
  AssignmentIndOutlined,
  AttachEmailOutlined,
  EditCalendarOutlined,
  InventoryOutlined,
  MarkEmailReadOutlined,
} from "@mui/icons-material";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import React from "react";
import { Navigate } from "react-router-dom";
import AdminClient from "../../../app/client";
import ClientCreate from "../../../app/client/components/ClientCreate";
import ClientUpdate from "../../../app/client/components/ClientUpdate";
import OfferPreview from "../../../app/client/components/OfferPreview";
import AdminDashboard from "../../../app/dashboard";
import AdminInvoice from "../../../app/invoice";
import InvoiceCreate from "../../../app/invoice/components/InvoiceCreate";
import InvoicePreview from "../../../app/invoice/components/InvoicePreview";
import InvoiceUpdate from "../../../app/invoice/components/InvoiceUpdate";
import AdminModule from "../../../app/module";
import ModuleUpdate from "../../../app/module/components/ModuleUpdate";
import AdminUser from "../../../app/user";
import UserCreate from "../../../app/user/components/UserCreate";
import UserUpdate from "../../../app/user/components/UserUpdate";
import AdminVersion from "../../../app/version";
import VersionCreate from "../../../app/version/components/VersionCreate";
import VersionUpdate from "../../../app/version/components/VersionUpdate";
import AdminEmailList from "../../../app/email-list";
import EmailListStats from "../../../app/email-list/components/EmailListStats";
import EmailListPreview from "../../../app/email-list/components/EmailListPreview";
import AdminEmailTemplates from "../../../app/email-template";
import EmailTemplateCreate from "../../../app/email-template/components/EmailTemplateCreate";
import EmailTemplateUpdate from "../../../app/email-template/components/EmailTemplateUpdate";

export const adminRoutes = [
  {
    path: "/dashboard",
    showInSidebar: true,
    title: "header.dashboard",
    component: <AdminDashboard />,
    icon: <DashboardOutlinedIcon />,
  },

  {
    path: "/user",
    showInSidebar: true,
    title: "header.user",
    component: <AdminUser />,
    icon: <Groups2OutlinedIcon />,
  },
  {
    path: "/user/create",
    component: <UserCreate />,
  },
  {
    path: "/user/update/:id",
    component: <UserUpdate />,
  },
  {
    path: "/invoice",
    showInSidebar: true,
    title: "header.invoice",
    component: <AdminInvoice />,
    icon: <AttachEmailOutlined />,
  },
  {
    path: "/invoices/preview/:id",
    component: <InvoicePreview />,
  },
  {
    path: "/invoice/create",
    component: <InvoiceCreate />,
  },
  {
    path: "/invoice/update/:id",
    component: <InvoiceUpdate />,
  },
  {
    path: "/client",
    showInSidebar: true,
    title: "header.client",
    component: <AdminClient />,
    icon: <AssignmentIndOutlined />,
  },
  {
    path: "/client/create",
    component: <ClientCreate />,
  },
  {
    path: "/client/update/:id",
    component: <ClientUpdate />,
  },
  {
    path: "/client/offer/:id",
    component: <OfferPreview />,
  },
  {
    path: "/module",
    showInSidebar: true,
    title: "header.module",
    component: <AdminModule />,
    icon: <InventoryOutlined />,
  },
  {
    path: "/module/update/:id",
    component: <ModuleUpdate />,
  },
  {
    path: "/email-list",
    showInSidebar: true,
    title: "header.emailList",
    component: <AdminEmailList />,
    icon: <MarkEmailReadOutlined />,
  },
  {
    path: "/email-list/stats/:id",
    component: <EmailListStats />,
  },
  {
    path: "/email-list/preview/:id",
    component: <EmailListPreview />,
  },
  {
    path: "/email-template",
    showInSidebar: true,
    title: "header.emailTemplate",
    component: <AdminEmailTemplates />,
    icon: <EditCalendarOutlined />,
  },
  {
    path: "/email-template/update/:id",
    component: <EmailTemplateUpdate />,
  },
  {
    path: "/email-template/create",
    component: <EmailTemplateCreate />,
  },
  {
    path: "/version",
    showInSidebar: true,
    title: "header.version",
    component: <AdminVersion />,
    icon: <AppShortcutOutlined />,
  },
  {
    path: "/version/create",
    component: <VersionCreate />,
  },
  {
    path: "/version/update/:id",
    component: <VersionUpdate />,
  },
  {
    path: "*",
    component: <Navigate to="/dashboard" />,
  },
];
